import { Login } from "widgets/login";

export const LoginPage = () => {
    return (
        <Login />
    );
};
